import {Component, Input, ViewChild} from '@angular/core';

@Component({
    selector: 'frageboegen-tab',
    templateUrl: './tab.component.html'
})
export class TabComponent {
    @Input() title: string;
    @Input() active = false;
    @Input() count: number;
    @Input() category: string[];
    @Input() name: string;
    @ViewChild('tableElement') tableElement;
}
